import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

var bnrimg = require('../../images/banner/error-404.png');

class Error extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Error 404" pagename="Error" description="Construyendo con visión, administrando con excelencia." bgimage={bnrimg}/>
                    {/* SECTION CONTENTG START */}
                    <div className="section-full mobile-page-padding p-tb150 bg-bottom-left bg-no-repeat" style={{ backgroundImage: 'url(images/background/bg-4.png)' }}>
                        <div className="container">
                            <div className="section-content">
                                <div className="page-notfound row">
                                    <div className="col-md-7">
                                        <img src={require('../../images/error.png')} alt="" />
                                    </div>
                                    <div className="col-md-5">
                                        <strong>Pagina no encontrada</strong>
                                        <span className="title">Error 404</span>
                                        <p>La pagina solicitada no se encuentra disponible</p>
                                        <NavLink to={"/"} title="Regresar al inicio" className="site-button btn-half"><span> Regresar al inicio</span></NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* SECTION CONTENT END */}
                </div>

                <Footer />
            </>
        );
    };
};

export default Error;